import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface MessageSlice {
    toastOpened: boolean;
    toastMessage: string;
    toastType: 'info' | 'error';
}

const initialState: MessageSlice = {
    toastOpened: false,
    toastMessage: '',
    toastType: 'info',
}

export const messageSlice = createSlice({
    name: 'message',
    initialState,
    reducers: {
        showErrorToast: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                toastOpened: true,
                toastMessage: action.payload,
                toastType: 'error',
            }
        },
        showInfoToast: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                toastOpened: true,
                toastMessage: action.payload,
                toastType: 'info',
            }
        },
        closeToast: (state) => {
            return {
                ...state,
                toastOpened: false,
                toastMessage: ''
            }
        }
    }
});
    

export const { showErrorToast, showInfoToast, closeToast } = messageSlice.actions;
export default messageSlice.reducer;